import React from "react";
import systalink from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HeroSection: React.FC = () => {

        const { t } = useTranslation();

        return (
                <React.Fragment>
                        {/* Logo app */}
                        <div>
                                <Link to="https://systalink.com" target="_blank" className="outline-none" >
                                        <img src={systalink} alt="Logo Systalink" className="" />
                                </Link>
                        </div>

                        {/* Description webApp */}
                        <div className="mt-20 flex flex-col gap-y-6">
                                <h1 className="font-semibold font-gellix lg:text-7xl md:text-2xl max-sm:text-4xl leading-tight">
                                        {t("send_capacity")} <br />{t("free_noauth")}
                                </h1>

                                <p className="lg:text-4xl font-gellix md:text-xl max-sm:text-2xl">
                                        {t("made_secure")} <br />{t("made_by")}
                                </p>
                        </div>
                        
                </React.Fragment>
        );
};

export default HeroSection;
